import { GradeSchema } from '../model/apprenticeModuleGrade.model'
import { ApprenticeshipModule } from '../model/apprenticeshipModule.model'
import { Company } from '../model/company.model'
import { Group } from '../model/group.model'
import { learningJournal } from '../model/learnJournal.model'
import { Observation } from '../model/observation'
import { Apprentice, Person } from '../model/person.model'
import { Profession } from '../model/profession.model'
import { TrialPeriodReport } from '../model/trialPeriodReport.model'

export const initialStoreState = {
  claims: [],
  user: {},
  loadingCounter: 0,
  errors: [],
  professions: [] as Profession[],
  apprentices: [] as Apprentice[],
  employees: [] as Person[],
  persons: [] as Person[],
  companies: [] as Company[],
  groups: [] as Group[],
  accounts: [] as any[],
  trialPeriodReports: [] as TrialPeriodReport[],
  observations: [] as Observation[],
  documentTypes: [] as DocumentType[],
  apprenticeshipModules: [] as ApprenticeshipModule[],
  gradeSchemas: [] as GradeSchema[],
  learningJournals: [] as learningJournal[],
}